import React from 'react'
import styled from 'styled-components'
import { Button } from 'antd'
import { SaveOutlined } from '@ant-design/icons'

const Container = styled.div`
    position: relative;
    width: 100%;
    padding: 40px 0 15px 0;
    .action-buttons {
        position: fixed;
        bottom: 0;
        right: 30px;
        padding: 20px;
        button {
            background-color: #1abc9c;
            border-color: #1abc9c;
            :hover {
                background-color: #1ec7a6;
                border-color: #1ec7a6;
            }
        }
    }
`

const SaveButton = ({ T, onSubmit }) => (
    <Container>
        <div className="action-buttons">
            <Button
                type="primary"
                htmlType={onSubmit ? 'button' : 'submit'}
                shape="round"
                size="large"
                icon={<SaveOutlined />}
                onClick={() => {
                    onSubmit && onSubmit()
                }}>
                {T('SAVE')}
            </Button>
        </div>
    </Container>
)

export default SaveButton
